import * as React from "react";
import { performLoginWithMonolith } from "actions/logIn";
//import { GoogleSigninButton } from "@worthy-npm/worthy-ui-components";
import { GoogleSigninButton } from "./GoogleSigninButton";
import rootStore from "reducers";
import WorthyApi from "../../lib/api/worthyApi";
import { Authenticator } from "../../lib/api/authenticator";
import { DEFAULT_PHONE } from "../../constants/register";
import {
  beforeRegistration,
  afterSuccessfulRegistration,
} from "../../actions/register";

const makeLoginWithGoogleCallback = ({
  params,
  setErrMsg,
  onSuccessfulLogin,
  isRegister,
  before,
  onSuccessfulRegister,
}) => {
  return (response) => {
    const handleError = (error) => {
      console.log("error ", error); // "Please Authenticate" or whatever returned from server
      if (error.isHttpError == 401 && error.data == "User not found") {
        setErrMsg(
          <>
            Email doesn't exist in our system.{" "}
            <a href="/register" className="blue">
              Register
            </a>
          </>
        );
      } else {
        setErrMsg("Something went wrong. Please try later.");
      }
    };
    before && before();
    if (isRegister) {
      const promise = WorthyApi.registerWithGoogle(response.credential);
      beforeRegistration(promise);
      return promise
        .then((regResponse) => {
          const isNewUser = !regResponse.data.loginSuccessful;
          if (isNewUser) {
            afterSuccessfulRegistration(
              {
                ...params,
                first_name: regResponse.data.user.first_name,
                last_name: regResponse.data.user.last_name,
                email: regResponse.data.user.email,
                phone: regResponse.data.user.phone || DEFAULT_PHONE,
              },
              regResponse
            );
            onSuccessfulRegister && onSuccessfulRegister(regResponse);
          } else {
            //LOG_IN
            rootStore
              .dispatch(performLoginWithMonolith(() => Promise.resolve()))
              .then(() => {
                onSuccessfulLogin && onSuccessfulLogin();
              })
              .catch(handleError);
          }
          setErrMsg("");
        })
        .catch(handleError);
    } else {
      return Authenticator.loginWithGoogle(response.credential)
        .then(() => {
          rootStore
            .dispatch(performLoginWithMonolith(() => Promise.resolve()))
            .then(() => {
              onSuccessfulLogin && onSuccessfulLogin();
            })
            .catch(handleError);
        })
        .catch(handleError);
    }
  };
};

function LoginWithGoogle({
  isRegister,
  onSuccessfulLogin,
  before,
  onSuccessfulRegister,
  params,
}) {
  const [errMsg, setErrMsg] = React.useState(null);
  const callback = makeLoginWithGoogleCallback({
    setErrMsg,
    onSuccessfulLogin,
    isRegister,
    before,
    onSuccessfulRegister,
    params,
  });

  const GOOGLE_CLIENT_ID = process.env.GOOGLE_SIGNIN_CLIENT_ID;

  // Don't render anything if the Google client id is not defined
  if (!(GOOGLE_CLIENT_ID && GOOGLE_CLIENT_ID != "")) return <div></div>;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "320px",
        margin: "0 auto",
      }}
    >
      <GoogleSigninButton
        callback={callback}
        clientId={GOOGLE_CLIENT_ID}
        width={319}
      />
      <div className={"login-error" + (errMsg ? "" : " hidden")}>{errMsg}</div>
      <div
        style={{
          display: "flex",
          width: "100%",
          color: "#cccccc",
          margin: "15px 0",
        }}
      >
        {" "}
        <hr style={{ width: "100%", height: "1px" }} />
        <div
          style={{
            margin: "0 0.5em",
            fontSize: "80%",
          }}
        >
          OR
        </div>
        <hr style={{ width: "100%", height: "1px" }} />
      </div>
    </div>
  );
}

export default LoginWithGoogle;
